import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './searchable-dropdown.scss';

export class SearchableDropdown extends Component {

  /**
   *Since the Select control uses the selected option object - { label: "Selected Option label", value: "id1" } - instead of
   just the Id (which the rest of the application uses), the control needs to get the entire object from the list of options
   using the selectedOptionId that was passed in by the application. Then it will know which option was selected. Furthermore,
   it will reset the dropdown text if no id is found in the option list.
   https://github.com/JedWatson/react-select/issues/828
   * @param {Guid} selectedOptionId The Id of the selected option in the options array.
   */
  getSelectedValue(selectedOptionId) {
    const option = this.props.options.find(m => m.value === selectedOptionId);
    if(option) return option;
    else return null;
  }

  render() {
    const { id, name, options, isLoading, isDisabled, value, onChange, placeholder, ariaDescribedBy, ariaLabel, ariaLabeledBy, autoFocus, instanceId } = this.props;
    return (
      <div>
        <Select
          inputId={id}
          name={name}
          options={options}
          isDisabled={isDisabled}
          isLoading={isLoading}
          value={this.getSelectedValue(value)}
          onChange={onChange}
          placeholder={placeholder}
          aria-describedby={ariaDescribedBy}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabeledBy}
          isSearchable={true}
          autoFocus={autoFocus}
          instanceId={instanceId}
          isClearable={false}
        />
      </div>
    );
  }
}

//default props:
//https://github.com/JedWatson/react-select/blob/master/src/Select.js
SearchableDropdown.defaultProps = {
  id: "searchable-dropdown",
  name: "searchable-dropdown",
  backspaceRemovesValue: false,
  placeholder: "--Select--",
  autoFocus: false,
  instanceId: "1",
}

SearchableDropdown.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaLabeledBy: PropTypes.string,
  options: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  instanceId: PropTypes.string,
};

export default SearchableDropdown;
